const FechaConfig ={

    FORMATO_FECHA: 'dd-MM-yyyy',
    FORMATO_FECHA_LARGA: 'dd MMMM yyyy'
};

export default FechaConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/fecha.config.js